import * as React from 'react'
import dynamic from 'next/dynamic'

import { HorizontalAlignment } from '@thg-commerce/enterprise-widget-accordion-container'
import { Input, PlatformMessage } from '@thg-commerce/gravity-elements'
import { KeyboardKeys } from '@thg-commerce/gravity-theme'

import { AccordionProps } from './HelpCentreCollection'
import {
  SearchButtonContainer,
  StyledMobileAccordionSearchContainer,
  StyledMobileAccordionSearchContent,
  StyledMobileNotFoundText,
  StyledSearchInputContainer,
} from './styles'

const SearchIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/SearchIcon'),
)

interface HelpCenterCollectionSearchProps {
  searchValue: string
  searchText: string
  foundSearchResults: AccordionProps[] | null
  noResultsFound: string
  handleInputOnChange: (inputValue: string) => void
  handleClearInput: () => void
  showNoResultsMessage: boolean
  resultsRef?: React.RefObject<HTMLDivElement>
  noResultsMessageRef?: React.RefObject<HTMLDivElement>
}

const SearchButton = (props: {
  handleKeyDown: (event: React.KeyboardEvent) => void
  handleSearchButtonClick: () => void
}) => {
  return (
    <SearchButtonContainer
      onClick={props.handleSearchButtonClick}
      onKeyDown={props.handleKeyDown}
    >
      <SearchIcon />
    </SearchButtonContainer>
  )
}
export const HelpCenterCollectionSearch = ({
  searchValue,
  searchText,
  foundSearchResults,
  noResultsFound,
  handleInputOnChange,
  handleClearInput,
  showNoResultsMessage,
  resultsRef,
  noResultsMessageRef,
}: HelpCenterCollectionSearchProps) => {
  const handleSearchButtonClick = () => {
    if (resultsRef?.current) {
      resultsRef.current.focus()
    } else if (noResultsMessageRef?.current) {
      noResultsMessageRef.current.focus()
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === KeyboardKeys.Enter) {
      handleSearchButtonClick()
    }
  }

  return (
    <StyledSearchInputContainer data-testid="help-center-search-container">
      <Input
        valueOverride={searchValue}
        label={searchText}
        labelHidden
        placeholder={searchText}
        autocomplete="off"
        delete
        svgIcon={
          <SearchButton
            handleKeyDown={handleKeyDown}
            handleSearchButtonClick={handleSearchButtonClick}
          />
        }
        svgIconLeftAlign={false}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          handleInputOnChange(e.target.value)
        }}
        clearInputValueHandler={handleClearInput}
        onKeyDown={handleKeyDown}
      />

      {!!foundSearchResults?.length && (
        <StyledMobileAccordionSearchContainer data-testid="mobile-search-content">
          {foundSearchResults.map((accordion, index) => (
            <StyledMobileAccordionSearchContent
              key={`mobile-search-content-${index}`}
              items={accordion.items}
              title={accordion.title}
              alignment={'left' as HorizontalAlignment}
              closeAllOnRender={true}
              contentPadding={true}
            />
          ))}
        </StyledMobileAccordionSearchContainer>
      )}

      {showNoResultsMessage && (
        <StyledMobileNotFoundText>
          <PlatformMessage type="info" text={noResultsFound} />
        </StyledMobileNotFoundText>
      )}
    </StyledSearchInputContainer>
  )
}
